export const SECRET_KEY =
  "97bafbf9bbc7e723d3b12bfd86392e95f7a30530356f238f8835ce4efcba6eb3";
export const FIREBASE_PUBLIC_KEY =
  "BBns7xVeAmFhOrCz6CcM76lEj57Q8GuXsTmxjAeuFabhbKvU3S_GAmM6PimIfnn22qo8nO16-X2HYmW3bDO8JpM";
